__turbopack_context__.v({
  "autherRoal": "STAboutUs-module__51glua__autherRoal",
  "facebook": "STAboutUs-module__51glua__facebook",
  "icon": "STAboutUs-module__51glua__icon",
  "instagram": "STAboutUs-module__51glua__instagram",
  "linkedin": "STAboutUs-module__51glua__linkedin",
  "memberImageWrapper": "STAboutUs-module__51glua__memberImageWrapper",
  "ourApproachIcon": "STAboutUs-module__51glua__ourApproachIcon",
  "ourApproachSection": "STAboutUs-module__51glua__ourApproachSection",
  "ourApproachcard": "STAboutUs-module__51glua__ourApproachcard",
  "ourApproachcardsWrapper": "STAboutUs-module__51glua__ourApproachcardsWrapper",
  "ourInnovationContent": "STAboutUs-module__51glua__ourInnovationContent",
  "ourInnovationHeading": "STAboutUs-module__51glua__ourInnovationHeading",
  "ourInnovationImageWrapper": "STAboutUs-module__51glua__ourInnovationImageWrapper",
  "ourLaboratoryContent": "STAboutUs-module__51glua__ourLaboratoryContent",
  "ourLaboratoryHeader": "STAboutUs-module__51glua__ourLaboratoryHeader",
  "ourLaboratoryImageWrapper": "STAboutUs-module__51glua__ourLaboratoryImageWrapper",
  "ourLaboratoryTag": "STAboutUs-module__51glua__ourLaboratoryTag",
  "ourLaboratoryValue": "STAboutUs-module__51glua__ourLaboratoryValue",
  "ourProcessDescription": "STAboutUs-module__51glua__ourProcessDescription",
  "ourSpecializationDesc": "STAboutUs-module__51glua__ourSpecializationDesc",
  "ourSpecializationSection": "STAboutUs-module__51glua__ourSpecializationSection",
  "ourTeamTitle": "STAboutUs-module__51glua__ourTeamTitle",
  "processArrow": "STAboutUs-module__51glua__processArrow",
  "processSteps": "STAboutUs-module__51glua__processSteps",
  "researchMissionContent": "STAboutUs-module__51glua__researchMissionContent",
  "researchMissionfeatureIcon": "STAboutUs-module__51glua__researchMissionfeatureIcon",
  "researchMissionfeaturesWrap": "STAboutUs-module__51glua__researchMissionfeaturesWrap",
  "reviewBadge": "STAboutUs-module__51glua__reviewBadge",
  "socialIcon": "STAboutUs-module__51glua__socialIcon",
  "specializationCardWrapper": "STAboutUs-module__51glua__specializationCardWrapper",
  "specializationImgWrapper": "STAboutUs-module__51glua__specializationImgWrapper",
  "step": "STAboutUs-module__51glua__step",
  "teamCardWrapper": "STAboutUs-module__51glua__teamCardWrapper",
  "testimonialCard": "STAboutUs-module__51glua__testimonialCard",
  "testimonialSwiper": "STAboutUs-module__51glua__testimonialSwiper",
});
